import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

interface Props {
  readonly title: string | undefined;
  readonly counter: number;
}

export const ItemTitle = (props: Props): React.ReactElement => {
  const { counter, title } = props;
  if (!title || title === '') {
    return <></>;
  }

  return (
    <Box mb={4}>
      <Typography fontSize={24} fontWeight={500} lineHeight="32px">
        {title.replaceAll('{{counter}}', String(counter))}
      </Typography>
    </Box>
  );
};
